<template>
  <div class="setting-body">
    <div class="head-operation">
      <el-button
        type="primary"
        @click="() => (editDialogVisible = true)"
      >新增发票抬头</el-button>
    </div>
    <div class="invoice-helper">
      <!-- 发票助手左侧区域，展示当前用户的所有发票列表 -->
      <el-scrollbar class="invoice-list">
        <div
          v-for="(item, index) in invoiceList"
          :key="index"
          class="invoice-item"
          :class="{
            active: currentInvoiceIndex === index
          }"
          @click="changeInvoice(index)"
        >
          <div class="invoice-item-name">
            <span class="text-ellipsis" :title="item.invoiceName">
              {{ item.invoiceName }}
            </span>
            <el-button
              v-if="canRemove(item)"
              type="text"
              icon="el-icon-delete invoice-item-delete"
              @click.prevent.stop="removeInvoice(item, index)"
            />
          </div>
          <div
            v-if="item.invoiceTitleType === invoiceTitleTypeDict.PERSONAL.value"
            class="invoice-item-bottom"
          ></div>
        </div>
      </el-scrollbar>

      <!-- 发票助手右侧区域，展示发票内容 -->
      <div class="invoice-content">
        <personal-invoice v-if="isPersonal" />
        <template v-else>
          <tab-switch
            :tab-list="tabList"
            @tabChange="changeTab"
          >
            <template v-slot:content="{ tab }">
              <span>{{ tab.alias }}</span>
            </template>
          </tab-switch>
          <general-invoice
            v-if="isGeneral"
            :company-id="currentInvoice.companyId"
            :invoice-address-id="currentInvoice.invoiceAddressId || ''"
            :is-employee="Boolean(companyId)"
          />
          <special-invoice
            v-else
            :company-id="currentInvoice.companyId"
            :invoice-address-id="currentInvoice.invoiceAddressId || ''"
            :is-employee="Boolean(companyId)"
          />
        </template>
      </div>
    </div>

    <custom-invoice-edit-dialog
      :visible.sync="editDialogVisible"
      @afterSubmit="setInvoiceListData"
    />
  </div>
</template>

<script>
// 组件
import SpecialInvoice from '@/components/PersonalCenter/SpecialInvoice'
import GeneralInvoice from '@/components/PersonalCenter/GeneralInvoice'
import PersonalInvoice from '@/components/PersonalCenter/PersonalInvoice'
import TabSwitch from '@/components/TabSwitch'
import CustomInvoiceEditDialog from '@/components/PersonalCenter/CustomInvoiceEditDialog'
// vuex
import { mapState } from 'vuex'
// 字典
import { invoiceTitleTypeDict, invoiceTypeDict } from '@/dictionary/financial'
// mixin
import personalMixin from '@/views/personal-center/personalMixin'
// 接口
import { getInvoiceCompanyApi, removeInvoiceApi } from '@/api/financial/invoice'
import { companyTypeDict } from '@/dictionary/company'

export default {
  name: 'InvoiceHelper',

  components: {
    SpecialInvoice,
    GeneralInvoice,
    PersonalInvoice,
    TabSwitch,
    CustomInvoiceEditDialog
  },

  mixins: [personalMixin],

  data() {
    return {
      invoiceType: invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value,
      invoiceTypeDict,
      invoiceTitleTypeDict,

      // 发票列表
      invoiceList: [
        {
          invoiceName: '个人发票',
          invoiceTitle: '',
          invoiceTitleType: invoiceTitleTypeDict.PERSONAL.value,
          isCustomize: false
        }
      ],
      // 当前发票抬头下标
      currentInvoiceIndex: 0,

      tabList: invoiceTypeDict.array.slice(0, 2),

      // 控制新增发票抬头弹窗显示
      editDialogVisible: false
    }
  },

  computed: {
    ...mapState('user', ['companyList']),
    ...mapState('company', ['companyId']),

    // 查看个人发票
    isPersonal() {
      return (
        this.currentInvoice.invoiceTitleType ===
        invoiceTitleTypeDict.PERSONAL.value
      )
    },

    // 查看专票
    isGeneral() {
      return (
        this.invoiceType === invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value
      )
    },

    // 当前发票抬头
    currentInvoice() {
      return this.invoiceList[this.currentInvoiceIndex]
    }
  },

  watch: {
    companyId(val) {
      this.currentCompanyId = val
    }
  },

  created() {
    this.currentCompanyId = this.companyId
    this.$store.dispatch('user/getJoinedCompany')
    this.setInvoiceListData()
  },

  methods: {
    /**
     * 获取发票列表
     */
    setInvoiceListData() {
      getInvoiceCompanyApi()
        .then(res => {
          console.log('获取发票列表', res)

          this.invoiceList = [
            {
              invoiceName: '个人发票',
              invoiceTitle: '',
              invoiceTitleType: invoiceTitleTypeDict.PERSONAL.value,
              isCustomize: false
            }
          ]

          const customList = res.data.map(item => {
            return {
              invoiceName: item.companyName,
              invoiceTitle: item.companyTaxNo,
              invoiceTitleType: invoiceTitleTypeDict.COMPANY.value,
              isCustomize: true,
              companyId: 0,
              employeeId: 0,
              invoiceAddressId: item.id
            }
          })
          this.invoiceList = this.invoiceList.concat(customList)
          this.$store
            .dispatch('user/getJoinedCompany')
            .then(() => {
              // 过滤自然人的企业
              const tempList = this.companyList
                .map(item => {
                  return {
                    invoiceName: item.companyName,
                    invoiceTitle: item.companyName,
                    invoiceTitleType: invoiceTitleTypeDict.COMPANY.value,
                    isCustomize: false,
                    companyId: item.companyId,
                    employeeId: item.employeeId,
                    companyType: item.companyType
                  }
                })
                .filter(
                  item => item.companyType !== companyTypeDict.PERSON.value
                )
              this.invoiceList = this.invoiceList.concat(tempList)
            })
            .catch(err => {
              console.error('获取发票列表失败', err)
              if (err?.message) this.$message.error(err.message)
            })
        })
        .catch(err => {
          console.error('获取发票列表失败', err)
          if (err?.data?.message) this.$message.error(err.data.message)
        })
    },

    /**
     * 切换发票抬头
     */
    changeInvoice(index) {
      this.currentInvoiceIndex = index
    },

    /**
     * 检查当前发票是否可删除
     * @param {Object} item 发票信息
     * @return {Boolean} 是否可删除
     */
    canRemove(item) {
      // 关联企业的发票信息和个人发票信息不可删除，其余可以删除
      return item.isCustomize
    },

    /**
     * 删除发票
     * @param {Object} item 发票信息
     * @param {Number} index 发票下标
     */
    removeInvoice(item, index) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeInvoiceApi(item.invoiceAddressId)
            .then(res => {
              this.$message.success('删除成功')
              this.setInvoiceListData()
            })
            .catch(err => {
              console.error('删除发票失败', err)
              if (err?.data?.message) this.$message.error(err.data.message)
            })
        })
        .catch(() => {})
    },

    /**
     * 切换发票类型
     * @param {Number} index 发票类型下标
     */
    changeTab(index) {
      this.invoiceType = this.tabList[index].value
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-body {
  width: 1030px;
  //padding: 20px;
  background-color: $white-color;
  overflow: hidden;
  position: relative;
  border-radius: 4px;
  display: flex;
  flex-direction: column;

  // 顶部操作栏
  .head-operation {
    padding: 20px 24px;
    border-bottom: 1px solid $info-fourth-color;
  }

  .invoice-helper {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    flex: 1;

    // 发票列表
    .invoice-list {
      width: 296px;
      height: 900px;
      overflow-y: auto;
      border-right: 1px solid $info-fourth-color;

      ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden !important;
      }

      // 发票列表项
      .invoice-item {
        padding: 14px 24px;
        cursor: pointer;
        position: relative;

        .invoice-item-name {
          color: $text-second-color;
          display: flex;
          align-items: stretch;
          justify-content: space-between;

          ::v-deep .invoice-item-delete {
            color: $text-third-color;
          }
        }

        .invoice-item-bottom {
          height: 1px;
          background-color: $info-fourth-color;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: 0 24px;
          z-index: 10;
        }

        &.active {
          background: $info-fourth-color;

          .invoice-item-name {
            color: $text-color;
            @include text-bold;
          }
        }
      }
    }

    // 发票具体内容
    .invoice-content {
      flex: 1;
      padding: 14px 24px;
    }
  }
}
</style>
